import { useUser, useUserUsageTypes } from "@shared/utils/hooks/misc";
import { useUserUsageLimits } from "@shared/features/settings/hooks";
import { sharedLib } from "@shared/services/shared.service";
import { UsageType } from "@shared/types";
import { HEDGING_BOTS_FEATURE_FLAG } from "@shared/common/constants";

const usePlanUsage = () => {
  const { user } = useUser();
  const { userUsageLimits, isLoading: isLoadingUsageLimits } =
    useUserUsageLimits(true);
  const { data: allQuotaUsage, isLoading: isLoadingQuotaUsage } =
    sharedLib.sharedApi.settings.useGetAllQuotaUsageQuery(undefined, {
      refetchOnMountOrArgChange: true,
    });
  const usageTypes = useUserUsageTypes();

  const isLoadingQuotas = isLoadingUsageLimits || isLoadingQuotaUsage;

  const currentUsageTypes = usageTypes.filter((usageType) => {
    const shouldHideHedgingBot =
      usageType === UsageType.HEDGING_BOT &&
      !user?.hasFeatureFlag(HEDGING_BOTS_FEATURE_FLAG);
    return usageType !== UsageType.ACTIVE_TRADE && !shouldHideHedgingBot;
  });

  const tradeCurrentUsage = allQuotaUsage?.[UsageType.ACTIVE_TRADE];
  const tradeUsageLimit = userUsageLimits?.[UsageType.ACTIVE_TRADE];

  const activeTradeCurrentUsageValueProps = {
    usageType: UsageType.ACTIVE_TRADE,
    currentUsage: tradeCurrentUsage,
    usageLimit: tradeUsageLimit,
  };
  return {
    user,
    userUsageLimits,
    allQuotaUsage,
    isLoadingQuotas,
    currentUsageTypes,
    tradeCurrentUsage,
    tradeUsageLimit,
    activeTradeCurrentUsageValueProps,
  };
};

export default usePlanUsage;
